import { Typography } from "@mui/material";
import React from "react";
import CookieConsent from "react-cookie-consent";
import { CookiesConfirmBox } from "../cookiesConfirmBox/cookiesConfirmBox";
import './rejectCookies.scss';
// import { useCookies } from "react-cookie";
import Cookies from "js-cookie";
import { EnableCookies } from "../enableCookies.tsx/enableCookies";
import { CookiesConsent } from "../cookiesConsent";

export const RejectCookiesConsent: React.FC<any> = () => {
	const [confirmCookiesPopup, setConfirmCookiesPopup] = React.useState<any>(false)
	// const [cookies, setCookie] = useCookies<any>();
	// const enableCookie = Cookies.get("enableCookies")
	const [enableCookiePopup, setEnableCookiePopup] = React.useState(false)
	const [goBack, setGoBack] = React.useState(false);
	let expire = new Date();
	let days: any = 365;
	expire.setTime(+ expire + (days * 86400000));

	// const yesButtonCall = () => {
	// 	if (navigator.cookieEnabled && (enableCookie == "false" || enableCookie == undefined)) {
	// 		setCookie('enableCookies', true, { path: '/', expires: expire });
	// 		window.location.reload();
	// 	}
	// 	else {
	// 		setEnableCookiePopup(true)
	// 	}
	// }

	// const noButtonCall = () => {
	// 	setConfirmCookiesPopup(true);
	// 	Cookies.remove('enableCookies');
	// }

	const backButtonCall = () => {
		Cookies.remove('enableCookies');
		setGoBack(true);
	}

	return (
		<>
			<div className="rejetcookiesWrapper">
				<CookieConsent
					containerClasses="cookiesConsent"
					debug={true}
					location="bottom"
					cookieName="enableCookies"
					buttonText="Back"
					overlay
					buttonClasses='acceptButton'
					contentClasses="contentClass"
					onAccept={backButtonCall}
					buttonWrapperClasses={"buttonWrapper"}
				>
					<div className="contentClassWrapper">
						<div className="cookiesTopContent">
							<Typography className="cookiesTitle" >We understand your decision and we thank you for visiting Infraclear. Unfortunately, our website cannot function without the use of cookies.</Typography>
							<Typography className="cookiesDesc">To opt to accept cookies, either select “Back” or refresh this page.</Typography>
							<div >
							</div>
						</div>
					</div>
				</CookieConsent>
				{
					confirmCookiesPopup && <CookiesConfirmBox />
				}
				{
					enableCookiePopup &&
					<EnableCookies />
				}
			</div>
			{
				goBack && <CookiesConsent />
			}
		</>
	);
};